import { Component, input, InputSignal, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonType } from '../../store/subheader/type';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrl: './confirmation-dialog.component.scss',
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
  title: InputSignal<string> = input('');
  message: InputSignal<string> = input('');
  protected readonly ButtonType = ButtonType;
  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {}

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
